module.exports = __webpack_public_path__ + "img/empty-covers.9f93ea7c.svg";